import {React} from 'react'
import '../Contact.css';
import LogoComponent from '../subComponents/LogoComponent'
import {DarkTheme} from './Themes';
import styled, {ThemeProvider} from 'styled-components';
import ParticleComponent from '../subComponents/ParticleComponent';
import ContactForm from '../subComponents/ContactForm';
import ContactInformation from '../subComponents/ContactInformation'


const Box = styled.div`
background-color: ${props => props.theme.body};
width: 100vw;
height:100vh;
position: relative;
overflow: hidden;
`

const ContactUs = () => {
    

  

    return (
        <>
        <ThemeProvider theme={DarkTheme}>
        <Box>

        <LogoComponent theme='dark'/>
        <ParticleComponent theme='dark' />

        
        <section className="contact">
    
            <p className='section-header'>Contact</p>
    
            <div className="contact-wrapper" >

                < ContactForm />

              <hr className="contact-hr" />
    
              <div className="direct-contact-container" style={{marginLeft:100}}>

                <ContactInformation/>

              </div>
    
            </div>
          </section> 
         
        </Box>

        </ThemeProvider>
</>
  )
}

export default ContactUs